import { inject, Injectable } from '@angular/core';
import { DevincoConnectUserData } from '@core/auth/interfaces';
import { environment } from '@env/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SupportUserService {
  private oidc = inject(OidcSecurityService);

  isSupportUser(): Observable<boolean> {
    return this.oidc
      .getUserData()
      .pipe(
        map(
          (data: DevincoConnectUserData) =>
            !environment.production ||
            (data.email.includes('support@devinco.com') &&
              !!environment.production)
        )
      );
  }
}
